




























import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Measurement} from "@/core/services/MedicaPro/models";

@Component({
    components: {}
})
export default class MeasurementListRowObjectiveValueView extends BaseComponent {

    // Bindings to parent
    @Prop() item!: Measurement;

    // Bindings to view
    public isReady = false;
    public value = -1;
    public color: 'green' | 'orange' | 'red' = 'green';

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.value = this.item.value ?? -1;
        this.updateColor();
        this.isReady = true;
    }

    private updateColor() {
        if (this.value > 16) {
            this.color = 'red';
        } else if (this.value > 8) {
            this.color = 'orange';
        } else {
            this.color = 'green';
        }
    }

}
